import GCarousel from "./g-carousel";

class RecentlyViewed extends GCarousel {
  constructor() {
    super();
    this.dynamic = true;
  }

  async fetchItems() {
    if (this.searchQueryString === "") {
      this.setAttribute("aria-hidden", true);
      return;
    }

    const response = await fetch(
      `/search?section_id=${this.sectionId}&type=product&q=${this.searchQueryString}`,
      {
        credentials: "same-origin",
        method: "GET",
      }
    );
    const text = await response.text();
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = text;

    const newSplideList = tempDiv.querySelector('.splide__list');
    if (newSplideList && newSplideList.childElementCount > 0) {
      this.splideList.innerHTML = newSplideList.innerHTML;
      if(this.splide) {
        this.splide.refresh();
      }
    } else {
      this.setAttribute("aria-hidden", true);
    }
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  get isbn() {
    return this.dataset.isbn;
  }

  get recommendationsCount() {
    return Number(this.dataset.recommendationsCount);
  }

  get searchQueryString() {
    var items = JSON.parse(localStorage.getItem("recentlyViewedProducts") || "[]"); // If we are on a product template, we make sure to remove the main product from the related product

    if (items.includes(this.currentProductId)) {
      items.splice(items.indexOf(this.currentProductId), 1);
    }

    return items
      .map(function (item) {
        return "id:" + item;
      })
      .join(" OR ");
  }

  get currentProductId() {
    return Number(this.dataset.currentProductId) || null;
  }
}

if (!customElements.get("recently-viewed")) {
  customElements.define("recently-viewed", RecentlyViewed);
}
